module.exports = __webpack_public_path__ + "img/level_center_pointer.c06cd627.gif";